export default __webpack_public_path__ + "static/media/B0000.e3a453f8.png";